const BRANCH_LABELS = {
  then: 'Then',
  else: 'Else'
};

const getWorkflowStepBranchGroups = (step) => {
  let branchMap = {};

  if (step?.branchesByKey && typeof step.branchesByKey === 'object' && !Array.isArray(step.branchesByKey)) {
    branchMap = step.branchesByKey;
  } else if (step?.branches && typeof step.branches === 'object' && !Array.isArray(step.branches)) {
    branchMap = step.branches;
  }

  const branchOrder = String(step?.type || '').toLowerCase() === 'branch' ? ['then', 'else'] : Array.isArray(step?.branchOrder) ? step.branchOrder : [];
  const orderedKeys = [...branchOrder, ...Object.keys(branchMap)].map((key) => String(key || '').trim()).filter((key, index, keys) => key && Object.prototype.hasOwnProperty.call(branchMap, key) && keys.indexOf(key) === index);

  return orderedKeys.map((key) => ({
    key,
    label: BRANCH_LABELS[key] || key,
    steps: Array.isArray(branchMap[key]) ? branchMap[key] : []
  }));
};

export default getWorkflowStepBranchGroups;
